import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
}

export function formatDateTime(dateString) {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleString('tr-TR', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
}

export function formatCurrency(amount) {
    return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY'
    }).format(amount || 0);
}

// Turkish-style decimal: thousands separator '.', decimal ',' (e.g. 180.654,00)
export function formatTRNumber(value, decimals = 2) {
    const n = Number(value) || 0;
    return n.toLocaleString('tr-TR', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

// Parse user input that may use comma or dot as decimal separator
// Accepts "0,5", "0.5", "1.234,56" (TR), "1,234.56" (EN), trims spaces.
export function parseLocaleNumber(input) {
    if (input == null || input === '') return 0;
    if (typeof input === 'number') return input;
    let s = String(input).trim().replace(/\s/g, '');
    if (!s) return 0;
    const hasComma = s.includes(',');
    const hasDot = s.includes('.');
    if (hasComma && hasDot) {
        // Whichever is rightmost is the decimal separator
        if (s.lastIndexOf(',') > s.lastIndexOf('.')) {
            s = s.replace(/\./g, '').replace(',', '.');
        } else {
            s = s.replace(/,/g, '');
        }
    } else if (hasComma) {
        s = s.replace(',', '.');
    }
    const n = parseFloat(s);
    return isNaN(n) ? 0 : n;
}

export function getStatusColor(status) {
    const colors = {
        pending: 'bg-amber-100 text-amber-800 border-amber-200',
        assigned: 'bg-blue-100 text-blue-800 border-blue-200',
        in_progress: 'bg-purple-100 text-purple-800 border-purple-200',
        completed: 'bg-green-100 text-green-800 border-green-200',
        cancelled: 'bg-slate-100 text-slate-800 border-slate-200',
        draft: 'bg-slate-100 text-slate-800 border-slate-200',
        sent: 'bg-blue-100 text-blue-800 border-blue-200',
        approved: 'bg-green-100 text-green-800 border-green-200',
        rejected: 'bg-red-100 text-red-800 border-red-200',
        expired: 'bg-slate-100 text-slate-800 border-slate-200',
        active: 'bg-green-100 text-green-800 border-green-200',
        warranty_expiring: 'bg-amber-100 text-amber-800 border-amber-200',
        warranty_expired: 'bg-red-100 text-red-800 border-red-200',
        signed: 'bg-green-100 text-green-800 border-green-200',
    };
    return colors[status] || 'bg-slate-100 text-slate-800 border-slate-200';
}

export function getStatusLabel(status) {
    const labels = {
        pending: 'Beklemede',
        assigned: 'Atandı',
        in_progress: 'Devam Ediyor',
        completed: 'Tamamlandı',
        cancelled: 'İptal Edildi',
        draft: 'Taslak',
        sent: 'Gönderildi',
        approved: 'Onaylandı',
        rejected: 'Reddedildi',
        expired: 'Süresi Doldu',
        active: 'Aktif',
        warranty_expiring: 'Garanti Bitiyor',
        warranty_expired: 'Garanti Bitti',
        signed: 'İmzalandı',
    };
    return labels[status] || status;
}

export function getPriorityColor(priority) {
    const colors = {
        low: 'bg-slate-100 text-slate-700',
        medium: 'bg-blue-100 text-blue-700',
        high: 'bg-amber-100 text-amber-700',
        urgent: 'bg-red-100 text-red-700',
    };
    return colors[priority] || 'bg-slate-100 text-slate-700';
}

export function getPriorityLabel(priority) {
    const labels = {
        low: 'Düşük',
        medium: 'Orta',
        high: 'Yüksek',
        urgent: 'Acil',
    };
    return labels[priority] || priority;
}

export function getCategoryLabel(category) {
    const labels = {
        network: 'Ağ Cihazı',
        software: 'Yazılım Lisansı',
        low_voltage: 'Zayıf Akım',
        other: 'Diğer',
    };
    return labels[category] || category;
}

export function getCategoryColor(category) {
    const colors = {
        network: 'bg-blue-100 text-blue-800',
        software: 'bg-purple-100 text-purple-800',
        low_voltage: 'bg-amber-100 text-amber-800',
        other: 'bg-slate-100 text-slate-800',
    };
    return colors[category] || 'bg-slate-100 text-slate-800';
}

export function getDeviceTypeLabel(type) {
    const labels = {
        pc: 'Masaüstü PC',
        laptop: 'Laptop',
        printer: 'Yazıcı',
        scanner: 'Tarayıcı',
        server: 'Sunucu',
        network: 'Ağ Cihazı',
        other: 'Diğer',
    };
    return labels[type] || type;
}

export function getDeviceTypeColor(type) {
    const colors = {
        pc: 'bg-blue-100 text-blue-800',
        laptop: 'bg-indigo-100 text-indigo-800',
        printer: 'bg-green-100 text-green-800',
        scanner: 'bg-cyan-100 text-cyan-800',
        server: 'bg-red-100 text-red-800',
        network: 'bg-purple-100 text-purple-800',
        other: 'bg-slate-100 text-slate-800',
    };
    return colors[type] || 'bg-slate-100 text-slate-800';
}
